<main class="disc" aria-label="AskPC Disclaimer">
  <h1 class="disc__title">{{ content.title }}</h1>

  <div class="disc__content">
    <div class="disc__divider" aria-hidden="true"></div>
    @for (s of content.sections; track s.id) {
      <section class="disc__section" [attr.aria-label]="s.title">
        <h2 class="disc__sectionTitle">{{ s.title }}</h2>
        <p class="disc__sectionBody">{{ s.body }}</p>
      </section>
    }
  </div>
</main>
